import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal } from "../../component/common/"
import { CategoryModal } from "../../component/master"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { createCategory, getCategoryListDetails, editCategory, deleteCategory } from "../../redux/actions/master"
import { getSNo } from "../../services/helperFunctions"

import { LoaderWrapper } from "../../HOC"

import NoImage from '../../assets/images/noimage.png';

class categoryClass extends Component {
	state = {
		headerDetails: [
			{
				label: 'S.No',
			},
			{
				label: 'Image',
			},
			{
				label: 'Title',
			},
			{
				label: 'Status',
			},
			{
				label: 'Action'
			},

		],
		filter: [


			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 2
			}


		],
		categoryLists: {

		},
		selectedFilter: 'Active',
		categoryDetails: {
			title: '',
			cover_image: ' '

		},
		isError: false,
		isOpen: false,
		isEdit: false,
		ConfirmModalOpenStatus: false,
		id: ''
	}


	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentDidMount() {
		this.setState({
			categoryLists: this.props.categoryLists
		})
	}


	requestStatus = (status) => {
		if (status === 0) {
			return <Badge
				type={2}
				label={"Deactive"}
			/>
		}

		else if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		}

	}

	handleFilter = (query, value, name) => {

		if (name == "filter") {

			this.setState({
				selectedFilter: query
			})
			query = {
				page: 1,
				filter: query
			}
		}


		this.props.getCategoryListDetails(query)


	}




	handleAdd = () => {
		this.setState({
			isOpen: true
		})
	}



	handleEdit = (index) => {

		let { categoryLists: { list } } = this.props

		let categoryDetails = list[index]

		this.setState({
			isEdit: true,
			categoryDetails,
			currentIndex: index

		})

		this.toggle("isOpen")

	}


	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}

	handleModal = () => {

		let temp = {
			title: '',
			cover_image: '',
			description: '',
		}

		this.setState({
			isError: false,
			isOpen: false,
			isEdit: false,
			categoryDetails: temp

		})
	}

	handleDeleteToggle = (id) => {

		this.setState({
			id
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {
		let { id } = this.state

		this.props.deleteCategory(id).then(() => {

			this.props.getCategoryListDetails()

			this.toggleDelete("ConfirmModalOpenStatus")

		})

	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}




	render() {

		let { headerDetails, filter, selectedFilter, categoryDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus } = this.state
		let { categoryLists } = this.props
		let IsEmpty = categoryLists.list.length > 0

		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>Category
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleAdd()}
						>Add Category</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center">Category List</h5>
								<div className="ml-auto d-flex align-items-center">
									{/* <UncontrolledDropdown setActiveFromChild className="filter-dropdown">
										<DropdownToggle tag="a" className="custom-caret dropdown-toggle-link">
											Filter by: {selectedFilter}
										</DropdownToggle>
										<DropdownMenu>
											{filter.map(({ label, value }, index) => {
												return (
													<DropdownItem
														onClick={e => this.handleFilter(label, value, "filter")}
														key={index}
													>
														{label}
													</DropdownItem>

												)
											})}
										</DropdownMenu>
									</UncontrolledDropdown> */}

									<div className="search-box position-relative  ml-3">

										{/* <Filters
											queryHandler={(query) => this.handleFilter(query)}
											isDropDownFilter={false}
										/> */}
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									pageMeta={categoryLists.pageMeta}
									queryHandler={(query) => this.handleFilter(query)}


								>
									{categoryLists.list.map((item, index) => {
										let { id, title, status, cover_imageUrl } = item

										return (
											<tr
												key={index}  >
												<td>{getSNo(categoryLists.pageMeta, index)}</td>
												<td>
													<img className="list-img" src={cover_imageUrl ? cover_imageUrl : NoImage} />
												</td>
												<td>{title}</td>
												<td>{this.requestStatus(status)}</td>
												<td>
													<a className="mr-25"
														onClick={e => this.handleEdit(index)}
													>
														<i className="icon-pencil  text-primary cursor-pointer"
														></i>
													</a>
													<a ><i
														className="icon-trash txt-danger text-primary cursor-pointer"
														onClick={e => this.handleDeleteToggle(id)}
													></i></a>
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>



				<SliderOverlay isOpen={isOpen} toggle={this.handleModal} size='30%'>
					<div className="side-slider h-100 position-relative">
						<div className="h-100 flex-with-center">
							<CategoryModal
								isError={isError}
								toggle={this.handleModal}
								modalDetails={categoryDetails}
								isEdit={isEdit}
							/>
						</div>

					</div>
				</SliderOverlay>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete Category?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		categoryLists: state.master.categoryLists
	}


};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getCategoryListDetails,
		createCategory,
		editCategory,
		deleteCategory
	}, dispatch)
};

let actions = ['getCategoryListDetails']

let component = LoaderWrapper(categoryClass)({ actions })

export const Category = connect(mapStateToProps, mapDispatchToProps)(component)

